import { Withdrawal } from "@workspace/domain/src/features/withdrawal";
import * as z from "zod";
import { OC } from "../../utils";
import { AdminWithdrawal } from "./schema";

export const withdrawalContract = OC.router({
  getAll: OC.meta({ permissions: true })
    .input(AdminWithdrawal.GetAll)
    .output(z.array(AdminWithdrawal.WithdrawalEntry)),

  count: OC.meta({ permissions: true })
    .input(AdminWithdrawal.Count)
    .output(z.number()),

  withdraw: OC.meta({
    alters: true,
    permissions: true,
    auditLog: { modelName: "WITHDRAWAL", action: "CREATE" },
    aragon: "withdrawal_created",
  })
    .input(AdminWithdrawal.Withdraw)
    .output(AdminWithdrawal.WithdrawalEntry),

  getAvailableBalance: OC.meta({ permissions: true }).output(z.number()),

  getMethod: OC.meta({ permissions: true }).output(
    Withdrawal.WithdrawalMethod.nullable(),
  ),
});
